
import React from "react";
import "react-awesome-slider/dist/styles.css";
import "./App.css";
import "./App.css";
import SolutionEcosystem from "./SolutionEcosystem/SolutionEcosystem";
import AgribusinessStack from "../AgribusinessStack/AgribusinessStack";

import "react-awesome-slider/dist/styles.css";
import "./App.css";
import "./App.css";
import "../BusinessPartner/BusinessPartner.css";
// Main component for DTN Deployment for Agri-Storage Entrepreneurs
export default class App extends React.Component {

  render() {
    return (
      <>
        {/* Banner section */}
        <AgribusinessStack
          classname="agri-storage-entreprenur"
          level1="System Integrator"
          level2="Agribusiness"
          level3="Agri-Storage Entrepreneur"
        />

        {/* Section representing DTN deployment for agri-storage entrepreneurs */}
        <SolutionEcosystem
          title="DTN Deployment for Agri-Storage Entrepreneur"
          type="ASE"
          bodycopy="ASN is a type of DTN network where agri-storage entrepreneurs can join to monetize unutilized storing capacity."
        />
      </>
    );
  }
}

